module.exports = __webpack_public_path__ + "img/image-mt-6.25192889.png";